module.exports = __webpack_public_path__ + "img/CrediYa-Fondo-Inversiones.3f0690f6.png";